export default __webpack_public_path__ + "static/media/noimage-placeholder.b5dc767b.svg";